import { render, staticRenderFns } from "./AchatEncours.vue?vue&type=template&id=01a4182c&"
import script from "./AchatEncours.vue?vue&type=script&lang=ts&"
export * from "./AchatEncours.vue?vue&type=script&lang=ts&"
import style0 from "./AchatEncours.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports